/* eslint-disable */
import * as Types from '../../../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ReportDataQueryVariables = Types.Exact<{
  brandCode: Types.Scalars['String'];
  args: Types.RmDataArgs;
  hotelId?: Types.InputMaybe<Types.Scalars['Int']>;
  startDate?: Types.InputMaybe<Types.Scalars['String']>;
  endDate?: Types.InputMaybe<Types.Scalars['String']>;
  snapshotDate?: Types.InputMaybe<Types.Scalars['String']>;
  groupDailyStartDate2?: Types.InputMaybe<Types.Scalars['String']>;
  groupDailyEndDate2?: Types.InputMaybe<Types.Scalars['String']>;
  useCache?: Types.InputMaybe<Types.Scalars['Boolean']>;
  currentRateTableArgs2: Types.CurrentRateTableArgs;
  filters: Types.FindHotelMonthlyBudgetArgs;
}>;


export type ReportDataQuery = { __typename?: 'Query', liveData?: Array<{ __typename?: 'LiveData', brand_code?: any | null, stay_date?: any | null, snapshot_date?: any | null, date_month?: string | null, date_ym?: string | null, date_yq?: string | null, rt_rooms_committed?: number | null } | null> | null, rmData?: Array<{ __typename?: 'RmData', stay_date?: any | null, stay_date_ly?: any | null, snapshot_date?: any | null, adr?: number | null, adr_ly?: number | null, adr_ly_final?: number | null, date_month?: string | null, date_ym?: string | null, date_yq?: string | null, delta_1day?: number | null, delta_3day?: number | null, delta_7day?: number | null, dow?: string | null, group_blocked?: number | null, group_sold?: number | null, group_sold_ly_final?: number | null, lvl_a_status?: string | null, lvl_a_details?: string | null, lvl_b_status?: string | null, lvl_b_details?: string | null, lvl_c_status?: string | null, lvl_c_details?: string | null, lvl_d_status?: string | null, lvl_d_details?: string | null, lvl_e_status?: string | null, lvl_e_details?: string | null, lvl_f_status?: string | null, lvl_f_details?: string | null, lvl_g_status?: string | null, lvl_g_details?: string | null, lvl_h_status?: string | null, lvl_h_details?: string | null, occ?: number | null, occ_ly?: number | null, occ_ly_final?: number | null, occ_rc?: number | null, ooo?: number | null, ooo_ly_final?: number | null, remaining?: number | null, revenue?: number | null, revenue_ly?: number | null, revenue_ly_final?: number | null, revpar?: number | null, revpar_ly_final?: number | null, sold?: number | null, sold_ly?: number | null, sold_ly_final?: number | null, total_capacity?: number | null, total_capacity_ly?: number | null, total_capacity_ly_final?: number | null, var_adr_ly?: number | null, var_adr_ly_final?: number | null, var_group_sold_ly_final?: number | null, var_occ_ly_final?: number | null, var_ooo_ly_final?: number | null, var_revenue_ly?: number | null, var_revenue_ly_final?: number | null, var_revpar_ly_final?: number | null, var_sold_ly?: number | null, var_sold_ly_final?: number | null } | null> | null, monthlyRoundUpForecast?: Array<{ __typename?: 'Forecast', stay_date?: any | null, date_month?: string | null, date_ym?: string | null, date_yq?: string | null, forecast_occ_1?: number | null, forecast_sold_1?: number | null, forecast_adr_1?: number | null, forecast_revenue_1?: number | null, fcstType?: string | null, forecast_sold_2?: number | null, forecast_adr_2?: number | null, forecast_revenue_2?: number | null, hotel_id?: number | null } | null> | null, groupDaily?: Array<{ __typename?: 'DailyGroupData', brand_code?: string | null, date_year?: string | null, date_ym?: string | null, date_yq?: string | null, date_yw?: string | null, stay_date?: string | null, details?: Array<{ __typename?: 'Group', brand_code?: string | null, description?: string | null, group_rooms_committed?: number | null, group_rooms_remaining?: number | null, group_rooms_sold?: number | null, is_past?: boolean | null, lowest_group_rate?: number | null, rate_code?: string | null, snapshot_date?: string | null, stay_date?: string | null } | null> | null } | null> | null, currentRateTable?: Array<{ __typename?: 'DailyRoomRate', brand_code?: any | null, stay_date?: any | null, snapshot_date?: any | null, date_month?: string | null, date_ym?: string | null, date_yq?: string | null, current_rate?: number | null } | null> | null, bestrevData?: Array<{ __typename?: 'BestrevData', stay_date?: string | null, date_month?: string | null, date_ym?: string | null, date_yq?: string | null, recommended_rate?: number | null, market_rate?: number | null, snapshot_date?: string | null } | null> | null, hotelMonthlyBudgets?: Array<{ __typename?: 'MonthlyBudget', id: string, hotel_id: number, stay_date?: any | null, date_ym?: string | null, month: number, year: number, budget_adr?: number | null, budget_sold?: number | null, budget_revenue?: number | null } | null> | null };


export const ReportDataDocument = gql`
    query ReportData($brandCode: String!, $args: RmDataArgs!, $hotelId: Int, $startDate: String, $endDate: String, $snapshotDate: String, $groupDailyStartDate2: String, $groupDailyEndDate2: String, $useCache: Boolean, $currentRateTableArgs2: CurrentRateTableArgs!, $filters: FindHotelMonthlyBudgetArgs!) {
  liveData(brandCode: $brandCode, snapshotDate: $snapshotDate) {
    brand_code
    stay_date
    snapshot_date
    date_month
    date_ym
    date_yq
    rt_rooms_committed
  }
  rmData(args: $args) {
    stay_date
    stay_date_ly
    snapshot_date
    adr
    adr_ly
    adr_ly_final
    date_month
    date_ym
    date_yq
    delta_1day
    delta_3day
    delta_7day
    dow
    group_blocked
    group_sold
    group_sold_ly_final
    lvl_a_status
    lvl_a_details
    lvl_b_status
    lvl_b_details
    lvl_c_status
    lvl_c_details
    lvl_d_status
    lvl_d_details
    lvl_e_status
    lvl_e_details
    lvl_f_status
    lvl_f_details
    lvl_g_status
    lvl_g_details
    lvl_h_status
    lvl_h_details
    occ
    occ_ly
    occ_ly_final
    occ_rc
    ooo
    ooo_ly_final
    remaining
    revenue
    revenue_ly
    revenue_ly_final
    revpar
    revpar_ly_final
    sold
    sold_ly
    sold_ly_final
    total_capacity
    total_capacity_ly
    total_capacity_ly_final
    var_adr_ly
    var_adr_ly_final
    var_group_sold_ly_final
    var_occ_ly_final
    var_ooo_ly_final
    var_revenue_ly
    var_revenue_ly_final
    var_revpar_ly_final
    var_sold_ly
    var_sold_ly_final
  }
  monthlyRoundUpForecast: combinedHotelForecast(
    hotelId: $hotelId
    startDate: $startDate
    endDate: $endDate
    snapshotDate: $snapshotDate
  ) {
    stay_date
    date_month
    date_ym
    date_yq
    forecast_occ_1
    forecast_sold_1
    forecast_adr_1
    forecast_revenue_1
    fcstType
    forecast_sold_2
    forecast_adr_2
    forecast_revenue_2
    hotel_id
  }
  groupDaily(
    brandCode: $brandCode
    startDate: $groupDailyStartDate2
    endDate: $groupDailyEndDate2
    useCache: $useCache
  ) {
    brand_code
    date_year
    date_ym
    date_yq
    date_yw
    stay_date
    details {
      brand_code
      description
      group_rooms_committed
      group_rooms_remaining
      group_rooms_sold
      is_past
      lowest_group_rate
      rate_code
      snapshot_date
      stay_date
    }
  }
  currentRateTable(args: $currentRateTableArgs2) {
    brand_code
    stay_date
    snapshot_date
    date_month
    date_ym
    date_yq
    current_rate
  }
  bestrevData(brandCode: $brandCode) {
    stay_date
    date_month
    date_ym
    date_yq
    recommended_rate
    market_rate
    snapshot_date
  }
  hotelMonthlyBudgets(filters: $filters) {
    id
    hotel_id
    stay_date
    date_ym
    month
    year
    budget_adr
    budget_sold
    budget_revenue
  }
}
    `;

/**
 * __useReportDataQuery__
 *
 * To run a query within a React component, call `useReportDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportDataQuery({
 *   variables: {
 *      brandCode: // value for 'brandCode'
 *      args: // value for 'args'
 *      hotelId: // value for 'hotelId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      snapshotDate: // value for 'snapshotDate'
 *      groupDailyStartDate2: // value for 'groupDailyStartDate2'
 *      groupDailyEndDate2: // value for 'groupDailyEndDate2'
 *      useCache: // value for 'useCache'
 *      currentRateTableArgs2: // value for 'currentRateTableArgs2'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useReportDataQuery(baseOptions: Apollo.QueryHookOptions<ReportDataQuery, ReportDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportDataQuery, ReportDataQueryVariables>(ReportDataDocument, options);
      }
export function useReportDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportDataQuery, ReportDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportDataQuery, ReportDataQueryVariables>(ReportDataDocument, options);
        }
export type ReportDataQueryHookResult = ReturnType<typeof useReportDataQuery>;
export type ReportDataLazyQueryHookResult = ReturnType<typeof useReportDataLazyQuery>;
export type ReportDataQueryResult = Apollo.QueryResult<ReportDataQuery, ReportDataQueryVariables>;
export const namedOperations = {
  Query: {
    ReportData: 'ReportData'
  }
}